"use client";
import { useTranslation } from "react-i18next";
import Header from "../../components/header/index";

const NotFound = ({ logo }: { logo: string }) => {
  const { t } = useTranslation();
  const handleClick = () => {
    window.location.href = "/";
  };
  return (
    <>
      <Header logo={logo} center={false} />
      <div className="flex items-center w-full justify-center md:pb-[24px] pb-[48px]">
        <div className="w-full max-w-[1440px] md:pt-[131px] px-[171px] pb-[134px] justify-center flex">
          <div className="w-[1098px] h-[441px] bg-[url('../public/images/payment/pattern404.png')] bg-cover pt-[21.5px] flex flex-col items-center gap-[32px]">
            <div className="w-[335px] h-[300px]">
              <img src="/images/payment/404images.png" alt="404 images" />
            </div>
            <div className="flex flex-col items-center gap-[16px]">
              <div className="font-semibold text-[32px] leading-[32px]">
                {t("account_not_found")}
              </div>
              <div>{t("account_not_found_content")}</div>
            </div>
            <button
              onClick={handleClick}
              className="px-[24px] py-[12.5px] border-solid border-[1px] border-[#E2E4E9] rounded-[8px]"
            >
              {t("back_to_home")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
